var React = require('react');

function Diamond (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.03 3.437A1 1 0 019.858 3h28.286a1 1 0 01.826.437l7.858 11.539a1 1 0 01-.036 1.174l-22 28.462a1 1 0 01-1.582 0l-22-28.462a1 1 0 01-.036-1.174L9.031 3.437zm.542 2.758l-5.681 8.344h8.632l-2.95-8.344zm3.658 10.343H4.037l16.943 21.92-7.75-21.92zm13.79 21.92l16.943-21.92H34.77l-7.75 21.92zm5.629-21.92H15.351L24 41l8.649-24.462zm2.828-2h8.632l-5.681-8.343-2.95 8.344zM36.73 5H26.2l7.492 8.59L36.73 5zm-4.865 9.539L24 5.52l-7.864 9.018h15.728zM14.31 13.59L21.8 5H11.27l3.038 8.59z"}));
}

Diamond.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Diamond;

Diamond.default = Diamond;
